module.exports = __webpack_public_path__ + "static/media/Create_limited_time_offers3.bab78ed3.svg";